import { createFeatureSelector } from "@ngrx/store";
import { NotificationSettingsState } from "./model";

export const NOTIFICATION_SETTINGS_FEATURE_KEY = "vadmin.NOTIFICATION_SETTINGS";

export const getNotificationsFeatureState = createFeatureSelector<NotificationSettingsState>(
    NOTIFICATION_SETTINGS_FEATURE_KEY
);
